<template>
  <div class="alarm-top alarm-top-container">
    <div class="alarm-top-list">
      <ul>
        <li v-if="this.alarmTopList.length >0 " class="alarm-list-item" :key="index">
          <span v-for="item in alarmHead" class="span-head">{{item}}</span>
        </li>
        <li
          v-if="alarmList.routerLink != 'source'"
          v-for="item in alarmTopList"
          class="alarm-list-item"
          :key="index"
        >
          <span>
            <Tooltip v-if="item.itemName != null&& item.itemName != ''" placement="top-start">
              <span>{{item.itemName}}</span>
              <div slot="content">{{item.itemName}}</div>
            </Tooltip>
            <span v-else>{{item.itemName}}</span>
          </span>
          <span>{{item.itemCategory}}</span>
          <span v-if="alarmList.routerLink != 'version'" class="span-level">{{item.itemLevel}}</span>
          <span>
            <a @click="alarmLink(item.itemCode)">{{item.totalAlarmNum}}</a>
          </span>
        </li>
        <li
          v-if="alarmList.routerLink == 'source'"
          v-for="item in alarmTopList"
          class="alarm-list-item"
          :key="index"
        >
          <span class="span-head">
            <a>{{item.source}}</a>
          </span>
          <span v-if="sfdc">{{item.sfdc}}</span>
          <span v-if="crm">{{item.crm}}</span>
          <span v-if="siac">{{item.siac}}</span>
          <span v-if="icms">{{item.icms}}</span>
          <span v-if="handwork">{{item.handwork}}</span>
          <span v-if="azCloud">{{item.azCloud}}</span>
          <span v-if="none">{{"0"}}</span>
          <!-- <span>
            <Tooltip v-if="item.icms != null && item.icms != ''" placement="top-start">
              <span>{{item.icms}}</span>
              <div slot="content">{{item.icms}}</div>
            </Tooltip>
            <span v-else>{{item.icms}}</span>
          </span>-->
        </li>
      </ul>
    </div>
    <!-- <div class="i-bottom-link">
      <router-link v-if="alarmList.routerLink!='source'" :to="{name:alarmList.routerLink}">更多 ></router-link>
      <router-link v-if="alarmList.routerLink == 'source'" :to="{name:'problem'}">更多 ></router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "WsAlarmList",
  props: ["alarmList"],
  data() {
    return {
      alarmHead: [],
      alarmTopList: [],
      siac: false,
      icms: false,
      azCloud: false,
      handwork: false,
      crm: false,
      sfdc: false,
      none: false
    };
  },
  methods: {
    initAlarmList() {
      this.alarmHead = this.alarmList.alarmHead;
      this.alarmTopList = this.alarmList.alarmTopList;
    },
    sourceCheck() {     

      this.siac = false;
      this.icms = false;
      this.azCloud = false;
      this.handwork = false;
      this.crm = false;
      this.sfdc = false;
      this.none = false;
      let source = this.alarmList.alarmHead;
      for (let i = source.length - 1; i >= 0; i--) {
        if (source[i] == "SIAC") {
          this.siac = true;
        } else if (source[i] == "ICMS") {
          this.icms = true;
        } else if (source[i] == "安仔云") {
          this.azCloud = true;
        } else if (source[i] == "手工收集") {
          this.handwork = true;
        } else if (source[i] == "CRM") {
          this.crm = true;
        } else if (source[i] == "SFDC") {
          this.sfdc = true;
        } else if (source[i] == "暂无来源") {
          this.none = true;
        }
      }
    },
    alarmLink(itemCode) {
      if (this.alarmList.routerLink == "problem") {
        this.$router.push("/problem/" + itemCode);
      } else if (this.alarmList.routerLink == "security") {
        this.$router.push("/security/" + itemCode);
      } else {
        this.$router.push("/version/" + itemCode);
      }
    }
  },
  mounted() {
    this.sourceCheck();
    this.initAlarmList();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/alarmlist/WsAlarmList.vue